import * as React from 'react';
import ContentTile from './ContentTile';

export default () => (
  <ContentTile color="#0067F4">
    {/* People: the shared-with view. */}
    <circle cx="9" cy="8" r="3.5" />
    <path d="M3 20v-1.5A4.5 4.5 0 0 1 7.5 14h3a4.5 4.5 0 0 1 4.5 4.5V20" />
    <path d="M16 4.5a3.5 3.5 0 0 1 0 7M18 14a4.5 4.5 0 0 1 3 4.25V20" />
  </ContentTile>
);
